module.exports = __webpack_public_path__ + "static/img/cont47 (2).63991a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont47 (2).jpg
// module id = zyLC
// module chunks = 0